import { trimChatbotHistory } from '../utils/chatbotLimits'

class ChatbotService {
  constructor(apiService) {
    this.api = apiService
  }

  async downloadExport(fileId) {
    if (typeof fileId !== 'string' || !/^[A-Za-z0-9_-]+$/.test(fileId)) {
      throw new Error('Identificador de ficheiro inválido.')
    }
    // Fixed same-origin endpoint; never send the bearer token to a model-provided URL.
    // Reuse the configured instance so authentication/session expiry still applies.
    const response = await this.api.axios.get(`/intell/chatbot/download/${fileId}`, {
      baseURL: window.location.origin,
      responseType: 'blob',
    })
    return response.data
  }

  async sendMessage(message, conversationHistory = []) {
    try {
      // Get pharmacy_id from the apiService (which has access to user data)
      const pharmacy_id = this.api.pharmacy

      const response = await this.api.post('chatbot/chat', {
        message,
        pharmacy_id,
        conversation_history: trimChatbotHistory(conversationHistory),
      })

      // The backend returns { ok: true, data: { answer: "..." } }
      return response.data.data
    } catch (error) {
      throw error
    }
  }

  async streamMessage(message, onChunk) {
    try {
      const pharmacy_id = this.api.pharmacy

      const response = await this.api.post(
        'chatbot/chat',
        {
          message,
          pharmacy_id,
        },
        {
          responseType: 'stream',
          onDownloadProgress: (progressEvent) => {
            if (onChunk) {
              const chunk = progressEvent.event.target.response
              onChunk(chunk)
            }
          },
        },
      )
      return response.data.data
    } catch (error) {
      throw error
    }
  }
}

export default ChatbotService
